const content: { [key: string]: string } = {
  somethingWentWrong: "Something went wrong.",
  tryAgain: "Try Again",
};

export default content;
